export default [
	{
		type: "text",
		id: 1,
		items: [
			{
				id: 1,
				text: "Welche Anregungen haben Sie bezogen auf diese Veranstaltung (Lob/Kritik)?",
			},
			{
				id: 2,
				text: "Welche Themen wünschen Sie sich für zukünftige Veranstaltungen?",
			},
		],
	},
	{
		type: "uni",
		title: "Anmerkung: Bitte kreuzen Sie nur jene Aussagen an, die auf diese Veranstaltung zutreffen. Unpassende Aussagen können leer bleiben.",
		id: 2,
		items: [
			{
				id: 3,
				text: "Die Ziele waren für mich gut nachvollziehbar.",
			},
			{
				id: 4,
				text: "Die Veranstaltung war übersichtlich und verständlich.",
			},
			{
				id: 5,
				text: "In der Veranstaltung wurde ich zur Interaktion angeregt.",
			},
			{
				id: 6,
				text: "Ich wurde zum Mitdenken motiviert.",
			},
			{
				id: 7,
				text: "Meine Erwartungen an die Veranstaltung im Kurzformat wurden erfüllt.",
			},
			{
				id: 8,
				text: "Insgesamt fand ich die Veranstaltung im Kurzformat gut.",
			},
			{
				id: 9,
				text: "Ich würde die Veranstaltung im Kurzformat weiterempfehlen.",
			},
			{
				id: 10,
				text: "Die Referent/innen waren motivierend.",
			},
			{
				id: 11,
				text: "Die Referent/innen ermöglichten eine gute Arbeitsatmosphäre.",
			},
			{
				id: 12,
				text: "Die Referent/innen gaben mir die Möglichkeit, mich an der Bearbeitung des Themas zu beteiligen.",
			},
			{
				id: 13,
				text: "Die Referent/innen waren fachlich kompetent.",
			},
			{
				id: 14,
				text: "Das Veranstaltungsthema ist für meine berufliche, universitäre und/oder persönliche Entwicklung relevant.",
			},
			{
				id: 15,
				text: "Ich habe das Gefühl, in der Veranstaltung wichtige Impulse erhalten zu haben.",
			},
			{
				id: 16,
				text: "Ich habe Ideen wie ich das Thema auf die Praxis transferieren kann.",
			},
			{
				id: 17,
				text: "Ich hatte Gelegenheit, meine Anliegen zu reflektieren.",
			},
		],
	},
	{
		type: "age",
		id: 3,
		items: [
			{
				id: 18,
				text: "Alter: ",
			},
		],
	},
	{
		type: "special",
		id: 4,
		items: [
			{
				id: 19,
				text: "Ich bin ein/e ",
				label: [
					{
						id: 1,
						text: "Lehrende/r",
					},
					{
						id: 2,
						text: "Studierende/r",
					},
				],
			},
		],
	},
	{
		type: "text",
		id: 5,
		items: [
			{
				id: 20,
				text: "Semesterzahl (falls Studierende/r)",
				type: "small",
			},
			{
				id: 21,
				text: "Angestrebter Abschluss (falls Studierende/r)",
				type: "medium",
			},
		],
	},
];
